export enum Musters {
    USEbizUnicolour = 'USEbizUnicolour',
    USEbizStripes = 'USEbizStripes',
}
